import { handleErrorApi } from "../../helpers/randoms";
import ComprasService from "../../services/ComprasService";
import { types } from "../../types/types";
import { finishSpinner, startSpinner } from "../ui/spinner";

export const TraerTrackingSolicitud = (idSolicitud) => async (dispatch) => {
    dispatch(startSpinner());
    try {
        
        const response = await ComprasService.TraerTrackingSolicitud(idSolicitud);
        const body = await response.json(); 
        if(response.ok){
            dispatch({type: types.trackingSolicitudesCotizacionSuccess,
            payload: body});
            dispatch(finishSpinner())
        }else{
            throw body; 
        }
    } catch (error) {
        dispatch(finishSpinner());
        dispatch({type: types.trackingSolicitudesCotizacionError})
        handleErrorApi(dispatch, error, "Error al traer los movimientos de la solicitud","Ha ocurrido un error. Intente nuevamente")
    }
};

export const TraerTrackingFacturacion = (idTramiteCompra) => async (dispatch) => {
    dispatch(startSpinner());
    try {
        
        const response = await ComprasService.TraerTrackingFacturacion(idTramiteCompra);
        const body = await response.json(); 
        if(response.ok){
            dispatch({type: types.trackingFacturacionComprasSuccess,
            payload: body});
            dispatch(finishSpinner())
        }else{
            throw body; 
        }
    } catch (error) {
        dispatch(finishSpinner());
        dispatch({type: types.trackingFacturacionComprasError})
        handleErrorApi(dispatch, error, "Error al traer los movimientos de la facturacion","Ha ocurrido un error. Intente nuevamente")
    }
};